import { Box, Fab, Grid, Tooltip, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useNavigate } from "react-router";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useEffect, useMemo, useState } from "react";
import { setUserDetail, setbusinessChooseTab } from "../app/store/reducer";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router/dist";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import PersonIcon from "@mui/icons-material/Person";
import StorefrontIcon from "@mui/icons-material/Storefront";
import TableBarIcon from "@mui/icons-material/TableBar";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import SearchIcon from "@mui/icons-material/Search";
import HandshakeIcon from "@mui/icons-material/Handshake";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { routePath } from "../constants/routePath";
import LogOutPop from "./logoutPop";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { capitalizeFirstLetter } from "../app/common/commonFunction";
export default function BussinessMangment() {
  const navigate = useNavigate();
  const headerMenu = useSelector((state) => state.reducer.headerMenu);
  const [header1, setHeader1] = useState([]);
  const [header2, setHeader2] = useState([]);
  const [openChild, setOpenChild] = useState(null);

  // const arrN = (urlHeaderMenu) => {
  //   let arr1 = [...header1];

  //   let arr2 = [...header2];

  //   if (arr1.length == 0) {
  //     urlHeaderMenu.forEach((element, index) => {
  //       if (index % 2 == 0) {
  //         arr1.push(element);
  //       } else {
  //         arr2.push(element);
  //       }
  //       setHeader1(arr1);
  //       setHeader2(arr2);
  //     });
  //   }
  // };
  const iconsObj = {
    PersonIcon: PersonIcon,
    StorefrontIcon: StorefrontIcon,
    TableBarIcon: TableBarIcon,
    TableRestaurantIcon: TableRestaurantIcon,
    SearchIcon: SearchIcon,
    HandshakeIcon: HandshakeIcon,
    DashboardIcon: DashboardIcon,
    CurrencyRupeeOutlinedIcon: CurrencyRupeeOutlinedIcon,
    SettingsOutlinedIcon: SettingsOutlinedIcon,
    LockOutlinedIcon: LockOutlinedIcon,
    HeadsetMicOutlinedIcon: HeadsetMicOutlinedIcon,
    ShareOutlinedIcon: ShareOutlinedIcon,
    LogoutOutlinedIcon: PowerSettingsNewIcon,
  };
  const sideBarMenu = useSelector((state) => state.reducer.sideBarMenu);
  const bussinessMangementMenu = useSelector(
    (state) => state.reducer.bussinessMangementMenu,
  );
  const dispatch = useDispatch();

  const location = useLocation();
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(-1);
  // useEffect(() => {
  //   const indexRoute3 = bussinessMangementMenu.findIndex(
  //     (it) => it.route === location.pathname,
  //   );

  //   //console.log("currentPage ", currentPage);

  //   setCurrentPage(indexRoute3);
  // }, [location.pathname]);
  // useEffect(() => {
  //   if (bussinessMangementMenu[currentPage]?.tab) {
  //     dispatch(
  //       setbusinessChooseTab({
  //         value: bussinessMangementMenu[currentPage]?.tab[0]?.value,
  //         label: bussinessMangementMenu[currentPage]?.tab[0]?.label,
  //       }),
  //     );
  //   } else {
  //     dispatch(
  //       setbusinessChooseTab({
  //         value: bussinessMangementMenu[0]?.value,
  //         label: "",
  //       }),
  //     );
  //   }
  // }, [currentPage]);

  const allowedMenus = useMemo(() => {
    return bussinessMangementMenu.filter((item) =>
      headerMenu.some(
        (header) => header.systemFuctionName === item.systemFuctionName,
      ),
    );
  }, [bussinessMangementMenu, headerMenu]);
  
  useEffect(() => {
    if (allowedMenus.length === 0) return;

    // Only run once when nothing selected
    if (currentPage === -1) {
      setCurrentPage(0);
    }
  }, [allowedMenus, currentPage]);

//  useEffect(() => {
//    if (currentPage === -1) return;

//    const currentMenu = allowedMenus[currentPage];
//    if (!currentMenu?.tab?.length) return;

//    const firstTab = currentMenu.tab[0];

//    if (firstTab.children?.length > 0) {
//      setOpenChild(firstTab.value);

//      dispatch(
//        setbusinessChooseTab({
//          value: firstTab.children[0].value,
//          label: firstTab.children[0].label,
//        }),
//      );
//    } else {
//      setOpenChild(null);

//      dispatch(
//        setbusinessChooseTab({
//          value: firstTab.value,
//          label: firstTab.label,
//        }),
//      );
//    }
//  }, [currentPage]);
useEffect(() => {
  if (!allowedMenus.length) return;

  const menuIndex = allowedMenus.findIndex(
    (menu) =>
      menu.route === location.pathname ||
      menu.tab?.some((tab) =>
        tab.children?.some((child) => child.route === location.pathname),
      ),
  );

  if (menuIndex !== -1) {
    setCurrentPage(menuIndex);
  }
}, [location.pathname, allowedMenus]);

useEffect(() => {
  if (currentPage === -1) return;

  const currentMenu = allowedMenus[currentPage];

  if (!currentMenu?.tab?.length) return;

  // Find tab/child matching current URL
  for (let tab of currentMenu.tab) {
    if (tab.route === location.pathname) {
      dispatch(
        setbusinessChooseTab({
          value: tab.value,
          label: tab.label,
        }),
      );
      return;
    }

    if (tab.children?.length) {
      const childMatch = tab.children.find(
        (child) => child.route === location.pathname,
      );

      if (childMatch) {
        setOpenChild(tab.value);

        dispatch(
          setbusinessChooseTab({
            value: childMatch.value,
            label: childMatch.label,
          }),
        );
        return;
      }
    }
  }

  // fallback default tab
  dispatch(
    setbusinessChooseTab({
      value: currentMenu.tab[0].value,
      label: currentMenu.tab[0].label,
    }),
  );
}, [currentPage, location.pathname]);


  useEffect(() => {
    // const currentMenu = bussinessMangementMenu[currentPage];
    const currentMenu = allowedMenus[currentPage];

    if (currentMenu?.tab?.length > 0) {
      const firstTab = currentMenu.tab[0];

      if (firstTab.children?.length > 0) {
        setOpenChild(firstTab.value);
        dispatch(
          setbusinessChooseTab({
            value: firstTab.children[0].value,
            label: firstTab.children[0].label,
          }),
        );
      }
    }
  }, [currentPage]);

  useEffect(() => {
    // only close dropdown when route is totally different menu
    if (currentPage === -1) {
      setOpenChild(null);
    }
  }, [location.pathname]);
  console.log("bussinessMangementMenu ", bussinessMangementMenu);

  return (
    <Grid
      container
      spacing={0}
      sx={{
        // position: "sticky",
        top: "104px",
        pl: "5px",

        background: "#E3E3FF",
        overflowY: "auto",
        height: "auto",
        scrollbarWidth: "thin",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {},
        "&::-webkit-scrollbar-thumb": {
          background: (theme) => theme.palette.secondary.main, // Color of the thumb (scrollbar handle)
          borderRadius: "6px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#FFC107",
        },
      }}
    >
      <Grid sx={{ height: "auto" }} item md={12}>
        {allowedMenus?.map((item, index) => {
          const indexRoute = bussinessMangementMenu.findIndex(
            (it) => it.systemFuctionName === item.systemFuctionName,
          );
          const IconComponent =
            iconsObj[bussinessMangementMenu[indexRoute]?.icon];
          const indexRouteRilg = headerMenu.findIndex(
            (it) => it.systemFuctionName === item.systemFuctionName,
          );

          if (!headerMenu[indexRouteRilg]?.systemFuctionName) {
            return;
          }
          // console.log(
          //   `index : ${index}, length :${bussinessMangementMenu.length}`
          // );
          return (
            <>
              <Box
                key={"siderbar" + index}
                bgcolor="primary"
                sx={{
                  padding:
                    item.systemFuctionName === "Sign Out" ? "4px" : "10px",
                  borderBottom:
                    index !== bussinessMangementMenu.length - 1
                      ? currentPage === index && item.tab
                        ? ""
                        : "1px solid #ADADCD"
                      : "",
                  background: currentPage === index ? "#E3E3FF" : "",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontFamily: "'Montserrat', sans-serif",
                  cursor: "pointer",
                  transition: "0.3s",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentPage(index);
                  // ✅ Navigate first
                  navigate(item.route);

                  // ✅ If this menu has tabs
                  if (item.tab && item.tab.length > 0) {
                    const firstTab = item.tab[0];

                    // ✅ If first tab has children
                    if (firstTab.children && firstTab.children.length > 0) {
                      const firstChild = firstTab.children[0];
                      setOpenChild(firstTab.value);
                      dispatch(
                        setbusinessChooseTab({
                          value: firstChild.value,
                          label: firstChild.label,
                        }),
                      );
                    } else {
                      dispatch(
                        setbusinessChooseTab({
                          value: firstTab.value,
                          label: firstTab.label,
                        }),
                      );
                    }
                  }
                }}
              >
                <Typography
                  variant="standard"
                  color="#01008B"
                  sx={{
                    borderBottom:
                      currentPage === index ? "1px solid #01008B" : "",
                    fontWeight: currentPage === index ? "600" : "400",
                    fontSize: {
                      xs: "12px",
                      sm: "12px",
                      md: "14px",
                      lg: "15px",
                    },
                    fontFamily: "'Montserrat', sans-serif",
                  }}
                >
                  {" "}
                  {/* {item.regionalFunctionName} */}
                  {(function () {
                    const indexRoute = headerMenu.findIndex(
                      (it) => it.systemFuctionName === item.systemFuctionName,
                    );
                    if (!indexRoute) {
                      return capitalizeFirstLetter(
                        headerMenu[indexRoute]?.systemFuctionName,
                      );
                    }
                    // if (NameData[item?.systemFuctionName]) {
                    //   return item?.systemFuctionName;
                    // }
                    // if (item?.systemFuctionName == "Bulk Upload") {
                    //   return capitalizeFirstLetter("Bulk Upload");
                    // }
                    // if (item?.systemFuctionName == "Purchase Managment") {
                    //   return capitalizeFirstLetter("Purchase Managment");
                    // }
                    // if (item?.systemFuctionName == "Bulk Message") {
                    //   return capitalizeFirstLetter("Bulk Message");
                    // }
                    // if (item?.systemFuctionName == "Items Information") {
                    //   return capitalizeFirstLetter("Services / Products");
                    // }
                    // if (item?.systemFuctionName == "Payment Structure") {
                    //   return capitalizeFirstLetter("Payment Structure");
                    // }
                    // if (item?.systemFuctionName == "Employee Payroll") {
                    //   return capitalizeFirstLetter("Employee Payroll");
                    // }
                    // if (item?.systemFuctionName == "Employee Attendance") {
                    //   return capitalizeFirstLetter("Employee Attendance");
                    // }
                    // if (item?.systemFuctionName == "Job Hiring Post") {
                    //   return capitalizeFirstLetter("Job Hiring Post");
                    // }

                    return capitalizeFirstLetter(
                      headerMenu[indexRoute]?.regionalFunctionName,
                    );
                  })()}
                </Typography>
                {item.tab ? (
                  currentPage === index ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowRightIcon />
                  )
                ) : (
                  ""
                )}
              </Box>
              {currentPage === index && item.tab && (
                <Box
                  sx={{ display: "block", borderBottom: "1px solid #ADADCD" }}
                >
                  {/* {item?.tab?.map((ele, index) => {
                    return (
                      <Box
                        sx={{
                          background:
                            businessChooseTab?.value == ele.value
                              ? "#C0BFFF"
                              : "",
                        }}
                      >
                        <ul>
                          <li style={{ color: "#01008B" }}>
                            <Box
                              key={"tab-item-" + index}
                              bgcolor="primary"
                              onClick={() => {
                                
                                dispatch(
                                  setbusinessChooseTab({
                                    value: ele.value,
                                    label: ele.label,
                                  })
                                );
                              }}
                              variant="standard"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",

                                cursor: "pointer",
                                padding: "7px 0px",
                                fontFamily: "'Montserrat', sans-serif",
                                transition: "0.3s",
                              }}
                              color={
                                businessChooseTab?.value == ele.value
                                  ? "#01008B"
                                  : "#01008B"
                              }
                              textAlign={"left"}
                            >
                              <Typography
                                variant="standard"
                                sx={{
                                  fontFamily: "'Montserrat', sans-serif",
                                  fontSize: {
                                    xs: "12px",
                                    sm: "10px",
                                    md: "15px",
                                  },
                                  fontWeight: "400",
                                }}
                                color={
                                  businessChooseTab?.value == ele.value
                                    ? "#01008B"
                                    : "#01008B"
                                }
                                textAlign={"left"}
                              >
                                {capitalizeFirstLetter(ele.label)}
                              </Typography>
                            </Box>
                          </li>
                        </ul>
                      </Box>
                    );
                  })} */}

                  {item?.tab?.map((ele, index) => {
                    const hasChildren = ele.children && ele.children.length > 0;
                    const isParentOpen = openChild === ele.value;
                    return (
                      <Box key={"tab-main-" + index}>
                        {/* MAIN TAB */}
                        <Box
                          sx={{
                            background:
                              businessChooseTab?.value === ele.value
                                ? "#C0BFFF"
                                : "",
                          }}
                        >
                          <ul>
                            <li style={{ color: "#01008B" }}>
                              <Box
                                variant="standard"
                                bgcolor="primary"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",

                                  cursor: "pointer",
                                  padding: "7px 0px",
                                  fontFamily: "'Montserrat', sans-serif",
                                  transition: "0.3s",
                                }}
                                color={
                                  businessChooseTab?.value == ele.value
                                    ? "#01008B"
                                    : "#01008B"
                                }
                                textAlign={"left"}
                                onClick={(e) => {
                                  if (hasChildren) {
                                    e.stopPropagation();
                                    // ✅ Toggle dropdown open/close
                                    const isAlreadyOpen =
                                      openChild === ele.value;

                                    // Close if already open
                                    if (isAlreadyOpen) {
                                      setOpenChild(null);
                                      return;
                                    }

                                    // ✅ Close other dropdown and open this one
                                    setOpenChild(ele.value);

                                    // ✅ Auto select first child when opening
                                    dispatch(
                                      setbusinessChooseTab({
                                        value: ele.children[0].value,
                                        label: ele.children[0].label,
                                      }),
                                    );
                                    if (
                                      ele.route &&
                                      location.pathname !== ele.route
                                    ) {
                                      navigate(ele.route);
                                    }
                                  } else {
                                    // ✅ Close any open dropdown
                                    setOpenChild(null);

                                    // ✅ Select normal tab value
                                    dispatch(
                                      setbusinessChooseTab({
                                        value: ele.value,
                                        label: ele.label,
                                      }),
                                    );
                                  }
                                }}
                              >
                                <Typography
                                  variant="standard"
                                  sx={{
                                    fontFamily: "'Montserrat', sans-serif",
                                    fontSize: {
                                      xs: "12px",
                                      sm: "10px",
                                      md: "14px",
                                      lg: "15px",
                                    },
                                    // fontWeight: "400",
                                    textDecoration: isParentOpen
                                      ? "underline"
                                      : "none",

                                    textDecorationColor: "#01008B",
                                    fontWeight:
                                      isParentOpen ||
                                      businessChooseTab?.value === ele.value
                                        ? "600"
                                        : "400",
                                  }}
                                  color={
                                    businessChooseTab?.value == ele.value
                                      ? "#01008B"
                                      : "#01008B"
                                  }
                                  textAlign={"left"}
                                >
                                  {capitalizeFirstLetter(ele.label)}
                                </Typography>

                                {/* Expand Icon */}
                                {hasChildren &&
                                  (openChild === ele.value ? (
                                    <KeyboardArrowDownIcon />
                                  ) : (
                                    <KeyboardArrowRightIcon />
                                  ))}
                              </Box>
                            </li>
                          </ul>
                        </Box>

                        {/* CHILDREN LIST WITH BULLETS */}
                        {hasChildren && openChild === ele.value && (
                          <Box sx={{ pl: {lg:5, md:4, sm:2, xs:5} }}>
                            <ul style={{ margin: 0, paddingLeft: "18px" }}>
                              {ele.children.map((child, cIndex) => {
                                const isChildSelected =
                                  businessChooseTab?.value === child.value;

                                return (
                                  <li
                                    key={"child-" + cIndex}
                                    style={{
                                      listStyleType: "circle",
                                      color: "#01008B",
                                      cursor: "pointer",
                                      padding: "5px 0px",
                                    }}
                                  >
                                    <Box
                                      onClick={() =>
                                        dispatch(
                                          setbusinessChooseTab({
                                            value: child.value,
                                            label: child.label,
                                          }),
                                        )
                                      }
                                      sx={{
                                        padding: "6px 8px",
                                        borderRadius: "4px",
                                        background: isChildSelected
                                          ? "#C0BFFF"
                                          : "transparent",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontSize: {
                                            xs: "11px",
                                            sm: "10px",
                                            md: "13px",
                                            lg: "14px",
                                          },
                                          fontFamily:
                                            "'Montserrat', sans-serif",
                                          fontWeight: isChildSelected
                                            ? "600"
                                            : "400",

                                          // ✅ Underline for selected child
                                          // textDecoration: isChildSelected
                                          //   ? "underline"
                                          //   : "none",
                                          // textDecorationColor: "#01008B",
                                        }}
                                      >
                                        {capitalizeFirstLetter(child.label)}
                                      </Typography>
                                    </Box>
                                  </li>
                                );
                              })}
                            </ul>
                          </Box>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              )}
            </>
          );
        })}
      </Grid>
      <LogOutPop open={open} setOpen={setOpen} />
    </Grid>
    // </Box>
  );
}
